import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../services/guards/login-guard.guard';
import { BibliaComponent } from './biblia/biblia.component';
import { FileComponent } from './file.component';
import { DetailEntradasComponent } from 'src/pages/detail-entradas/detail-entradas.component';
// import { MassServiceOrdersComponent } from 'src/pages/mass-service-orders/mass-service-orders.component'; // ANTIGUO OS / OP masivas (reemplazado por os-masivas / np-masivas)
import { MassOsGenerationComponent } from 'src/pages/mass-os-generation/mass-os-generation.component';
import { OrdersReportComponent } from 'src/pages/orders-report/orders-report.component';
import { ReservationsReportComponent } from 'src/pages/reservations-report/reservations-report.component';
import { ReporteFileComponent } from './reporte-file/reporte-file.component';
import { TicketeriaComponent } from './ticketeria/ticketeria.component';
import { FileProgrammingComponent } from 'src/pages/file-programming/file-programming.component';

const routes: Routes = [
  {
    path: '',
    component: FileComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: FileProgrammingComponent },
      {
        path: 'programacion',
        canActivate: [AuthGuard],
        component: FileProgrammingComponent,
      },
      {
        path: 'ticketeria',
        canActivate: [AuthGuard],
        component: TicketeriaComponent,
      },
      {
        path: 'reporte-file',
        canActivate: [AuthGuard],
        component: ReporteFileComponent,
      },
      // {
      //   path: 'files',
      //   canActivate: [AuthGuard],
      //   component: MassServiceOrdersComponent, // ANTIGUO OS / OP masivas (reemplazado por os-masivas / np-masivas)
      // },
      {
        path: 'os-masivas',
        canActivate: [AuthGuard],
        component: MassOsGenerationComponent,
      },
      {
        path: 'np-masivas',
        canActivate: [AuthGuard],
        component: MassOsGenerationComponent,
        data: { mode: 'np' }
      },
      {
        path: 'file/detail/entradas',
        canActivate: [AuthGuard],
        component: DetailEntradasComponent,
      },
      {
        path: 'reservas',
        canActivate: [AuthGuard],
        component: ReservationsReportComponent,
      },
      {
        path: 'ordenservicio',
        canActivate: [AuthGuard],
        component: OrdersReportComponent,
      },
      { path: 'biblia', canActivate: [AuthGuard], component: BibliaComponent },

      {
        path: 'salidas-fijas/programacion',
        canActivate: [AuthGuard],
        component: FileProgrammingComponent,
      },

      {
        path: 'file-hijo/programacion',
        canActivate: [AuthGuard],
        component: FileProgrammingComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FileRoutingModule {}
